import * as API from "middleware/api";

export const echeqRulesList = (filters) => {
    const { action, status, creationDates } = filters;
    const [dateFrom, dateTo] = creationDates ?? [];
    return API.executeWithAccessToken("/list.echeq.rules", {
        ...filters,
        action: action?.value,
        status: status?.value,
        dateFrom,
        dateTo,
    });
};

export const ruleActionPre = ({ idRule, document, actionType: actionEcheq }, orderedList, action, pageNumber) =>
    API.executeWithAccessToken("/echeq.rule.action.pre", {
        actionEcheq,
        idRule,
        document,
        orderedList,
        action,
        pageNumber,
    });
